import React from 'react';

// import { Container } from './styles';

const Loading: React.FC = () => {
  return <div />;
}

export default Loading;